// extracted by mini-css-extract-plugin
export default {"container_form":"students_container_form__V-6Z4","content_form":"students_content_form__b4UB6","double_input":"students_double_input__Tqz4L"};